import { ExamineeRegistrationStatus } from '@exam-center/graphql';
import { parseAsPageNumber } from '@shared/utils';
import {
  parseAsArrayOf,
  parseAsInteger,
  parseAsString,
  parseAsStringLiteral,
  useQueryStates,
} from 'nuqs';

export default function useProctoringRegistrationExamineeListSearchParams() {
  const [{ search, registrationStatus, page, pageSize }, setQueryParams] = useQueryStates({
    search: parseAsString.withDefault(''),
    registrationStatus: parseAsArrayOf(
      parseAsStringLiteral(Object.values(ExamineeRegistrationStatus)),
    ).withDefault([]),
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(50),
  });

  const changePageNumber = (page: number) => {
    setQueryParams({ page });
  };
  const changePageSize = (pageSize: number) => {
    setQueryParams({ pageSize });
  };
  const changeSearch = (search: string) => {
    setQueryParams({ search });
  };
  const changeRegistrationStatus = (registrationStatus: ExamineeRegistrationStatus[] | null) => {
    setQueryParams({ registrationStatus });
  };

  return [
    {
      search,
      registrationStatus,
      page,
      pageSize,
    },
    { changePageNumber, changePageSize, changeSearch, changeRegistrationStatus },
  ] as const;
}
